var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2112_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6754 12.0734C31.6754 14.1406 29.991 15.7484 28.0004 15.7484C25.9332 15.7484 24.3254 14.1406 24.3254 12.0734C24.3254 10.0828 25.9332 8.39844 28.0004 8.39844C29.991 8.39844 31.6754 10.0828 31.6754 12.0734ZM28.0004 40.2484C29.991 40.2484 31.6754 41.9328 31.6754 43.9234C31.6754 45.9906 29.991 47.5984 28.0004 47.5984C25.9332 47.5984 24.3254 45.9906 24.3254 43.9234C24.3254 41.9328 25.9332 40.2484 28.0004 40.2484ZM43.9254 24.3234C45.916 24.3234 47.6004 26.0078 47.6004 27.9984C47.6004 30.0656 45.916 31.6734 43.9254 31.6734C41.8582 31.6734 40.2504 30.0656 40.2504 27.9984C40.2504 26.0078 41.8582 24.3234 43.9254 24.3234ZM15.7504 27.9984C15.7504 30.0656 14.066 31.6734 12.0754 31.6734C10.0082 31.6734 8.40039 30.0656 8.40039 27.9984C8.40039 26.0078 10.0082 24.3234 12.0754 24.3234C14.066 24.3234 15.7504 26.0078 15.7504 27.9984ZM16.6691 35.6547C18.7363 35.6547 20.3441 37.2625 20.3441 39.3297C20.3441 41.3203 18.7363 43.0047 16.6691 43.0047C14.6785 43.0047 12.9941 41.3203 12.9941 39.3297C12.9941 37.2625 14.6785 35.6547 16.6691 35.6547ZM39.2551 35.6547C41.2457 35.6547 42.9301 37.2625 42.9301 39.3297C42.9301 41.3203 41.2457 43.0047 39.2551 43.0047C37.1879 43.0047 35.5801 41.3203 35.5801 39.3297C35.5801 37.2625 37.1879 35.6547 39.2551 35.6547ZM16.6691 13.0687C18.7363 13.0687 20.3441 14.7531 20.3441 16.7437C20.3441 18.8109 18.7363 20.4187 16.6691 20.4187C14.6785 20.4187 12.9941 18.8109 12.9941 16.7437C12.9941 14.7531 14.6785 13.0687 16.6691 13.0687Z",
    fill: "#AAAAAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2112_230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "matrix(-1 0 0 1 56 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.57b77ae0fc9ff0be671ee967a9796165.svg";
export { ForwardRef as ReactComponent };